export default (context, inject) => {
  const translatable = (item, text) => {
    return item[`${text}_${context.app.i18n.locale}`]
  }

  inject('translatable', translatable)
  context.$translatable = translatable
}
